import { IFiltersState } from './types';

const KEY = 'dashboardFilters';

const initialState: IFiltersState = {
  expanded: ['STUDENTS', 'OFFERS'],
  savedSearchValue: '',
};

const getFilters = (): IFiltersState => {
  try {
    const notParsed = window.localStorage.getItem(KEY);

    if (notParsed) {
      return JSON.parse(notParsed) as IFiltersState;
    }

    return initialState;
  } catch (error) {
    // If localStorage fails, return initial state
    console.warn('Failed to get filters from localStorage:', error);
    return initialState;
  }
};

const saveFilters = (data: IFiltersState) => {
  try {
    const str = JSON.stringify(data);
    window.localStorage.setItem(KEY, str);
  } catch (error) {
    // If localStorage fails, log warning but don't crash
    console.warn('Failed to save filters to localStorage:', error);
  }
};

export const filtersService = { getFilters, saveFilters };
